const indexItems = [
  {
    icon: 'ri-fire-line',
    color: 'text-primary-500',
    bg: 'bg-primary-50',
    title: '本周热播',
    desc: '全网观众最爱的热门电影实时排行',
    count: '榜单实时更新',
  },
  {
    icon: 'ri-rocket-line',
    color: 'text-accent-500',
    bg: 'bg-accent-50',
    title: '新片速递',
    desc: '最新上映电影第一时间上线片库',
    count: '每日更新',
  },
  {
    icon: 'ri-medal-line',
    color: 'text-primary-500',
    bg: 'bg-primary-50',
    title: '高分必看',
    desc: '豆瓣IMDb高分认证的经典佳作合集',
    count: '8.0分以上',
  },
  {
    icon: 'ri-earth-line',
    color: 'text-accent-500',
    bg: 'bg-accent-50',
    title: '国际院线',
    desc: '全球各大电影节获奖作品汇集',
    count: '戛纳/柏林/威尼斯',
  },
  {
    icon: 'ri-moon-line',
    color: 'text-primary-500',
    bg: 'bg-primary-50',
    title: '深夜剧场',
    desc: '悬疑惊悚与恐怖爱好者专属频道',
    count: '胆量测试',
  },
  {
    icon: 'ri-heart-line',
    color: 'text-accent-500',
    bg: 'bg-accent-50',
    title: '怀旧经典',
    desc: '90年代华语电影黄金时代重温',
    count: '时光记忆',
  },
  {
    icon: 'ri-parent-line',
    color: 'text-primary-500',
    bg: 'bg-primary-50',
    title: '亲子影院',
    desc: '适合全家一起观看的优质动画电影',
    count: '家庭时光',
  },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-3">
              主题索引
            </h2>
            <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
              七大主题频道，精准定位你的观影偏好
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
            {indexItems.slice(0, 4).map((item, i) => (
              <a
                key={i}
                href="#index"
                onClick={(e) => e.preventDefault()}
                className="group flex items-start gap-4 bg-background-50 rounded-xl p-5 border border-background-200/70 hover:border-accent-200/50 transition-all cursor-pointer"
              >
                <div className={`w-11 h-11 flex items-center justify-center rounded-xl ${item.bg} flex-shrink-0`}>
                  <i className={`${item.icon} text-xl ${item.color}`}></i>
                </div>
                <div className="min-w-0">
                  <h3 className="text-sm font-semibold text-foreground-950 mb-1 group-hover:text-accent-600 transition-colors">
                    {item.title}
                  </h3>
                  <p className="text-xs text-foreground-600 mb-1.5">{item.desc}</p>
                  <span className="text-xs text-foreground-400">{item.count}</span>
                </div>
              </a>
            ))}
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mt-4">
            {indexItems.slice(4, 7).map((item, i) => (
              <a
                key={i + 4}
                href="#index"
                onClick={(e) => e.preventDefault()}
                className="group flex items-start gap-4 bg-background-50 rounded-xl p-5 border border-background-200/70 hover:border-primary-200/50 transition-all cursor-pointer"
              >
                <div className={`w-11 h-11 flex items-center justify-center rounded-xl ${item.bg} flex-shrink-0`}>
                  <i className={`${item.icon} text-xl ${item.color}`}></i>
                </div>
                <div className="min-w-0">
                  <h3 className="text-sm font-semibold text-foreground-950 mb-1 group-hover:text-primary-600 transition-colors">
                    {item.title}
                  </h3>
                  <p className="text-xs text-foreground-600 mb-1.5">{item.desc}</p>
                  <span className="text-xs text-foreground-400">{item.count}</span>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}